'use strict';

exports.__esModule = true;

var _styledSystem = require('styled-system');

exports["default"] = _styledSystem.borders;
module.exports = exports['default'];